import he from 'he'
import DOMPurify from 'dompurify'

// Utility function to check if a string is encoded
const isEncoded = (str) => typeof str === 'string' && /&[a-zA-Z]+;/.test(str)

// Function to decode strings repeatedly until fully decoded
const whileIsEncoded = (str) => {
  let decodedContent = str
  let previousContent
  do {
    previousContent = decodedContent
    decodedContent = he.decode(decodedContent)
  } while (decodedContent !== previousContent && isEncoded(decodedContent))
  return decodedContent
}

// Function to conditionally decode strings
const conditionallyDecode = (str) => (isEncoded(str) ? whileIsEncoded(str) : str)

// Function to recursively decode all properties in an object or array
export const decodeHTML = (obj, seen = new WeakSet()) => {
  if (typeof obj === 'string') {
    return conditionallyDecode(obj)
  }

  if (Array.isArray(obj)) {
    return obj.map(item => decodeHTML(item, seen))
  }

  if (typeof obj === 'object' && obj !== null) {
    if (seen.has(obj)) {
      return obj
    }

    seen.add(obj)

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj[key] = decodeHTML(obj[key], seen)
      }
    }
  }

  return obj
}

// Function to sanitize HTML using DOMPurify to prevent XSS
export function sanitizeHTML(htmlString) {
  if (!DOMPurify || typeof DOMPurify.sanitize !== 'function') {
    console.error('Error: "DOMPurify" module or "sanitize" function not available.')
    return htmlString // Return the original string if decoding is not possible
  }
  return DOMPurify.sanitize(htmlString)
}
